function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
export function clsx() {
  for (var _len = arguments.length, list = new Array(_len), _key = 0; _key < _len; _key++) {
    list[_key] = arguments[_key];
  }

  return list.filter(function (item) {
    return !!item;
  }).join(" ");
}
export function getChildren(c) {
  var slides = [];
  React.Children.toArray(c).forEach(function (child) {
    var _child$type, _child$type2, _child$props$children, _child$props$children2;

    if (((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'Image') {
      slides.push(_objectSpread(_objectSpread({}, child), {}, {
        props: _objectSpread(_objectSpread({}, child.props), {}, {
          parentDisplayName: 'Swiper'
        })
      }));
    } else if (((_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === "Link" && ((_child$props$children = child.props.children) === null || _child$props$children === void 0 ? void 0 : (_child$props$children2 = _child$props$children.type) === null || _child$props$children2 === void 0 ? void 0 : _child$props$children2.displayName) === "Image") {
      slides.push(_objectSpread(_objectSpread({}, child.props.children), {}, {
        props: _objectSpread(_objectSpread({}, child.props.children.props), {}, {
          parentDisplayName: 'Link'
        })
      }));
    }
  });
  return {
    slides: slides
  };
}
export function guid() {
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }

  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}